export default __webpack_public_path__ + "static/media/service04.0fc7c730.png";